<div class="flex flex-col bg-[#505A78] h-full text-white">
  <div>
    <!-- <a mat-icon-button [routerLink]="'/dashboard'"><mat-icon matTooltip="View">dashboard</mat-icon></a> -->
    @if (authUserData$ | async; as authUserData) {
      <div class="flex justify-between items-center p-2">
        <div *ngIf="navExpanded">
          <div class="font-bold text-lg">
            {{
              authUserData?.User?.SuperUserAccessLevelName
                ? authUserData?.User?.SuperUserAccessLevelName
                : 'Default User'
            }}
          </div>
          <div class="font-semibold text-sm">
            {{ authUserData?.User?.FullName }}
          </div>
        </div>
        <button mat-icon-button (click)="toggleExpandNav()">
          <mat-icon matTooltip="View">{{
            navExpanded ? 'chevron_left' : 'chevron_right'
          }}</mat-icon>
        </button>
      </div>
    }
  </div>
  @if (navExpanded) {
    <div class="flex flex-col justify-between p-2">
      <div>
        <mat-list class="!flex !flex-col !justify-between !gap-5">
          @for (
            groupedModules of groupedModules$ | async;
            track groupedModules
          ) {
            <mat-accordion>
              <mat-expansion-panel
                class="!bg-[#505A78]"
                [expanded]="groupedModules.Expanded"
              >
                <mat-expansion-panel-header
                  class="!bg-[#ffffff0d] !text-white !rounded-md"
                >
                  <ng-container *ngIf="navExpanded">
                    <mat-panel-title class="!text-white !font-bold">
                      {{ groupedModules.GroupingName | titlecase }}
                    </mat-panel-title>
                  </ng-container>
                </mat-expansion-panel-header>

                @for (module of groupedModules.Modules; track module) {
                  <mat-list-item
                    [ngClass]="{ '!bg-[#ffffff0d]': module.isActive }"
                    [routerLink]="module.RouterLink"
                    (click)="setModuleActive(groupedModules, module)"
                  >
                    <a mat-button class="!text-white">
                      <mat-icon>{{ module.ModuleIcon }}</mat-icon>
                      <div *ngIf="navExpanded">
                        {{ module.ModuleNiceName | titlecase }}
                      </div>
                    </a>
                  </mat-list-item>
                }
              </mat-expansion-panel>
            </mat-accordion>
          }
        </mat-list>
      </div>
      <div>
        <mat-list>
          <mat-accordion>
            <mat-expansion-panel class="!bg-[#505A78]" [expanded]="true">
              <mat-expansion-panel-header
                class="!bg-[#ffffff0d] !text-white !rounded-md"
              >
                <ng-container *ngIf="navExpanded">
                  <mat-panel-title class="!text-white !font-bold">
                    Account
                  </mat-panel-title>
                </ng-container>
              </mat-expansion-panel-header>

              <mat-list-item (click)="logOut()">
                <a mat-button class="!text-white">
                  <mat-icon matTooltip="View">logout</mat-icon>
                  <span *ngIf="navExpanded">Log Out</span>
                </a>
              </mat-list-item>
            </mat-expansion-panel>
          </mat-accordion>
        </mat-list>
        <ng-container *ngTemplateOutlet="logoContent" />
      </div>
    </div>
  } @else {
    @for (groupedModules of groupedModules$ | async; track groupedModules) {
      <div>
        @for (module of groupedModules.Modules; track module) {
          <div
            (click)="setModuleActive(groupedModules, module)"
            [ngClass]="{ isActive: module.isActive }"
            class="flex justify-center items-center p-3 hover:cursor-pointer"
            matTooltip="{{ module.ModuleNiceName | titlecase }}"
            [matTooltipPosition]="'right'"
            [routerLink]="module.RouterLink"
          >
            <mat-icon>{{ module.ModuleIcon }}</mat-icon>
          </div>
        }
      </div>
    }
    <div class="flex justify-center items-center p-3 hover:cursor-pointer">
      <div (click)="logOut()">
        <mat-icon matTooltip="Logout">logout</mat-icon>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="logoContent" />
  }
</div>

<ng-template #logoContent> </ng-template>
